import { ModalDialog, IModalDialogProps } from '@ui/modal-dialog/dialog';
import {
  IWarehouseWithBagsCollapseProps,
  WarehouseWithBagsCollapse,
} from '@@/warehouses/components/warehouse-with-bags-collapse';
import { IWarehouse } from '@@/warehouses/ts';

export function SelectBagByWarehouseModal(props: ISelectBagByWarehouseModalProps) {
  const { title, warehouses, loading, bagFilter, onLoadBags, onSelect, onClose } =
    props;

  return (
    <ModalDialog
      title={title ?? 'Выберите источник'}
      actions={<></>}
      loading={loading}
      onClose={onClose}
    >
      {warehouses.map((elem) => (
        <WarehouseWithBagsCollapse
          key={elem.id}
          warehouse={elem}
          bagFilter={bagFilter}
          onLoadBags={onLoadBags}
          onSelectBag={onSelect}
        />
      ))}
    </ModalDialog>
  );
}

export interface ISelectBagByWarehouseModalProps {
  title?: IModalDialogProps['title'];
  warehouses: Array<IWarehouse>;
  loading: boolean;
  bagFilter?: IWarehouseWithBagsCollapseProps['bagFilter'];

  onLoadBags: IWarehouseWithBagsCollapseProps['onLoadBags'];
  onSelect: IWarehouseWithBagsCollapseProps['onSelectBag'];
  onClose: IModalDialogProps['onClose'];
}
